import React, { useState } from 'react'
import config from './config'

const DevicePermission = () => {
	const [permission, setPermission] = useState(false)

	if (window.DeviceOrientationEvent !== undefined &&
		typeof window.DeviceOrientationEvent.requestPermission === 'function') {

		window.DeviceOrientationEvent.requestPermission().then(function (response) {
			if ('granted' === response) {
				setPermission(true)
			} else {
				window.location.href = config.iOSErrorUrl;
			}
		})

		const panelClass = permission ?
			'urb-zoo-device-permission-panel-hide' :
			'urb-zoo-device-permission-panel-show'

		const onClickDevicePermission = () => {
			window.DeviceOrientationEvent.requestPermission().then(
				(res) => {
					if ('granted' === res) {
						setPermission(true)
						window.location.reload()
					}
				}
			)
		}

		return (
			<div
				className={panelClass}
			>
				スマートフォンの傾き情報を利用します<br />
				(iOS13以上が必要となります)
				<button
					onClick={onClickDevicePermission}
				>
					許可する
					</button>
			</div>
		)
	}

	return (
		<>
		</>
	)
}

export default DevicePermission